/* ============================================================
   pltx2-fitness-shared.js
   Reveal observer for all 5 Pilatix App page sections. Guarded
   so it only initializes once even if multiple fitness sections
   load this file (Shopify caches it).

   Watches [data-pltx2-fit-reveal] elements, adds .is-in when the
   element's top crosses 80% of viewport. Removes on exit so the
   reveal replays on scroll up.
   ============================================================ */
(function () {
  'use strict';
  if (window.__pltx2FitnessShared) return;
  window.__pltx2FitnessShared = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = false;

  function update() {
    pending = false;
    var triggerLine = window.innerHeight * 0.80;
    var items = document.querySelectorAll('[data-pltx2-fit-reveal]');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var rect = el.getBoundingClientRect();
      // skip elements that haven't been laid out yet
      if (rect.width === 0 && rect.height === 0) continue;
      var inView = rect.top < triggerLine;
      var hasClass = el.classList.contains('is-in');
      if (inView && !hasClass) {
        el.classList.add('is-in');
      } else if (!inView && hasClass) {
        // only remove if element has scrolled well past the trigger line —
        // avoids flicker right at the threshold
        if (rect.top > window.innerHeight * 0.95) el.classList.remove('is-in');
      }
    }
  }

  function onScroll() {
    if (pending) return;
    pending = true;
    // direct call (no rAF) — keeps trigger immediate even when paint loop is throttled
    update();
  }

  function init() {
    if (reduceMotion) {
      var items = document.querySelectorAll('[data-pltx2-fit-reveal]');
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();   // initial pass
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
